export interface StaffTipItemConfig {
    count: number
    unit?: string
    limit?: number
    title?: string
}

export const staffTipConfig: StaffTipItemConfig[] = [
    {
        count: 1,
        unit: '位',
    },
    {
        count: 6,
        unit: '位',
    },
    {
        count: 15,
        unit: '位',
    },
]

const versionConfig: Record<string, number> = {
    '0': 1,
    '1': 6,
    '-1': 6,
    '2': 15,
}

export const getStaffVersionNum = (version: number) => {
    return versionConfig[`${version}`] || 1
}
